import { useState } from "react";
import type { RoomMember } from "@grundbesitz/shared";
import { useStore } from "../../lib/store";
import { Button } from "../ui/Button";
import { readyBlocker, startBlocker } from "./lobbyLogic";

/** Fixed bottom bar: the one action that matters for this viewer, with the reason when it is unavailable. */
export function LobbyBar({ members, me, isHost }: { members: RoomMember[]; me: RoomMember | null; isHost: boolean }) {
  const lobbyUpdate = useStore((s) => s.lobbyUpdate);
  const startGame = useStore((s) => s.startGame);
  const [busy, setBusy] = useState(false);

  const blocker = isHost ? startBlocker(members) : null;

  let status: string;
  if (isHost) status = blocker ?? "Alle sind bereit. Du kannst starten.";
  else if (!me) status = "Warte auf den Host.";
  else if (me.ready) status = "Du bist bereit. Warte auf den Host.";
  else status = readyBlocker(me) ?? "Drücke „Bereit“, sobald du loslegen willst.";

  const start = async () => {
    setBusy(true);
    // The server may count the host as a player who has to be ready as well.
    if (me && !me.ready) await lobbyUpdate({ ready: true });
    await startGame();
    setBusy(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-30 border-t border-line bg-surface pb-[env(safe-area-inset-bottom)]">
      <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-2.5 sm:px-6">
        <p id="lobby-status" className="min-w-0 flex-1 text-sm text-ink" role="status">
          {status}
        </p>
        {isHost ? (
          <Button variant="primary" className="shrink-0 px-6" onClick={() => void start()} disabled={blocker !== null || busy} aria-describedby="lobby-status">
            Spiel starten
          </Button>
        ) : (
          me && (
            <Button
              variant={me.ready ? "secondary" : "primary"}
              className="shrink-0 px-6"
              aria-pressed={me.ready}
              disabled={readyBlocker(me) !== null && !me.ready}
              onClick={() => void lobbyUpdate({ ready: !me.ready })}
            >
              {me.ready ? "✓ Bereit" : "Bereit"}
            </Button>
          )
        )}
      </div>
    </div>
  );
}
